import React from "react";
import { View } from "react-native";
import tailwind from "tailwind-rn";

export const Layout: React.FC = ({ children }) => {
  return (
    <View style={tailwind("bg-indigo-900 h-full p-4 flex")}>{children}</View>
  );
};
